var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-text',{directives:[{name:"mask",rawName:"v-mask",value:(['XX.XXX.XXX/XXXX-##']),expression:"['XX.XXX.XXX/XXXX-##']"}],attrs:{"required":_vm.required,"label":_vm.label,"disabled":_vm.disabled},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }